import { Button } from "alm-react-components";
import moment from "moment-timezone";
import {
  useContext,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
} from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  ActionType,
  Tag,
  constants,
  daysBeforeNextQuarterProgram,
} from "../../../assets/constants/constants";
import ArrowRight from "../../../assets/images/svgicons/arrow-right.svg";

import { AppContext } from "../../../context/AppProvider";
import useQuaterListHook from "../../../hooks/useQuaterListHook";
import useSubscription from "../../../hooks/useSubscription";
import getLocalizedContent from "../../../lib/getLocalizedMetaData";
import {
  checkWeekStatus,
  isEnrollmentDateAvailable,
  isEnrollmentProgramOpen,
} from "../../../lib/utils";
import { apis } from "../../../services/alm";
import FundamentalProgram from "../../common/FundamentalProgram";
import withAlmToken from "../../common/withAlmToken";
import LearningProgramCard from "../../learning-program/LearningProgramCard";
import Achievements from "./Achievements";
import MyClasses from "./MyClasses";
import MyProgress from "./MyProgress";
import PageLoader from "../../common/loader/PageLoader";
import { DisabledCardPopOver } from "../../common/DisabledCardPopOver";

const MyStance = () => {
  const goToBadgesRef = useRef<any>(null);
  const [query] = useSearchParams();
  const goToBadges: any = query.get("goToBadges");

  const navigate = useNavigate();
  const { t } = useTranslation();
  const { quaterListData, currentQuater, getQuaterStartData } =
    useQuaterListHook();
  const { state, dispatch } = useContext(AppContext);
  const [myStanceData, setMyStanceData] = useState<any>([]);
  const [availableQuater, setCurrentAvailableQuatrter] = useState<any>({});
  const [loading, setLoading] = useState(true);

  const [learningProgramData, setlearningProgramData] = useState({
    data: [],
    included: [],
  });
  const [enrolledProgram, setEnrolledProgram] = useState<any>({
    data: [],
    completed: [],
    enrolledData: [],
  });
  const [sectionData, setSectionData] = useState<any>({
    subLos: [], // 14 including do not show
    included: [],
  });
  const [progressBarData, setProgressBarData] = useState<any>({
    documents: 0,
    videos: 0,
    exercise: 0,
    liveMeetings: 0,
  });

  const { callSubscription } = useSubscription();
  const executeScroll = () => {
    goToBadgesRef?.current?.scrollIntoView({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };
  useEffect(() => {
    if(state.user){
      if(!state.user?.corporateAccountId)
        callSubscription("valid");
    }
  }, [state.user]);
  // const currentQuater = getCurrentQuater()
  const programOverViewDetails = async () => {
    try {
      if (enrolledProgram?.enrolledData[0]?.id) {
        const response: any = await apis.getProgramList(
          enrolledProgram?.enrolledData[0]?.id
        );
        setSectionData({
          subLos: response?.data?.attributes.sections
            .map((res: any) => res?.loIds)
            .flat(1),
          included: response?.included,
        });
        setTimeout(() => setLoading(false), 2000);
      } else {
        setTimeout(() => setLoading(false), 2000);
      }
    } catch (error) {
      console.log("error", error);
      setTimeout(() => setLoading(false), 2000);
    }
  };

  const learningProgram = async () => {
    try {
      const params = availableQuater?.quarter + "-" + availableQuater?.year;
      const response: any = await apis.getLearningProgram(params);
      const enrolledData = response?.data.filter((item: any) => {
        return item?.relationships?.enrollment;
      });
      const enrolledCompletedId = enrolledData?.map((item: any) => {
        return item?.relationships?.enrollment?.data?.id;
      });
      const tags = response?.included
        ?.filter((res: any) => {
          return enrolledCompletedId.includes(res?.id);
        })
        ?.map((res: any) => res?.attributes?.state == constants.COMPLETED);
      const completedData = enrolledData?.filter((_: any, i: any) => tags[i]);
      setLoading(false);
      setEnrolledProgram({
        data: [...enrolledData, completedData],
        completed: completedData,
        enrolledData: enrolledData,
      });
      /**  filter out the quater listing program 
      // sll corporate leaner have the default program listing 
      // Non sll corporate leaner have all quater program
      */
      const quaterWiseDataUnenrolled = response?.data?.filter((item: any) => {
                return !item.relationships.enrollment;
              }).filter((data:any)=>{
                return  state?.user?.sllCorporateAccount  === 1  ? data?.attributes?.tags.includes(Tag.defaultProgram) : true
              }); 

      setlearningProgramData({
        data: quaterWiseDataUnenrolled,
        included: response?.included,
      });
      dispatch({
        type: "SET_ENROLLMENT",
        payload: isEnrollmentProgramOpen(
          response.included[0].attributes.enrollmentDeadline
        ),
      });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const lpData = async () => {
      let enrolledData;
      try {
        const data = getQuaterStartData(currentQuater);
        const params = data?.quarter + "-" + data?.year;
        const response: any = await apis.getLearningProgram(params);
        enrolledData = response?.data.filter((item: any) => {
          return item.relationships.enrollment;
        });
        return enrolledData.length;
      } catch (error) {
        console.log(error);
      }
    };
    lpData().then((res) => {
      const liveQuater = quaterListData?.filter((res: any) => {
        return isEnrollmentDateAvailable(res?.start);
      })[0];
      if (res) {
        setCurrentAvailableQuatrter(getQuaterStartData(currentQuater));
      } else if (!res && liveQuater) {
        setCurrentAvailableQuatrter(liveQuater);
      } else {
        quaterListData?.forEach((res: any, index: number) => {
          if (
            res?.quarter === currentQuater &&
            res?.year == new Date().getFullYear()
          ) {
            setCurrentAvailableQuatrter(quaterListData[index + 1]);
          }
        });
      }
    });
  }, [quaterListData]);
  // fudamental Program

  useEffect(() => {
    if (state?.user && availableQuater?.quarter) {
      learningProgram();
    }
  }, [state?.user, availableQuater]);

  useEffect(() => {
    programOverViewDetails();
  }, [enrolledProgram]);

  useLayoutEffect(() => {
    if (goToBadges) executeScroll();
    else window.scroll(0, 0);
  }, [myStanceData]);
  const filterationOfData = () => {
    const arr = [];
    let data = sectionData?.subLos?.map((item: any) => {
      return sectionData.included.find((res: any) => {
        return res?.id == item;
      });
    });
    data = data
      .filter((item: any) => !item?.attributes?.tags?.includes(Tag.doNotShow))
      .filter(
        (intro: any) =>
          !intro?.attributes?.tags?.includes(Tag.introductionVideo)
      )
      .filter(
        (item: any) => !item?.attributes?.tags?.includes(Tag.overviewIntroVideo)
      );
    const date = moment(availableQuater?.start);
    for (let i = 0; i < data.length; i++) {
      arr.push({
        ...data[i],
        startDate: moment(date).add(i * daysBeforeNextQuarterProgram, "days"),
      });
    }
    return arr;
  };
  useEffect(() => {
    if (sectionData) setMyStanceData(filterationOfData());
  }, [sectionData]);

  useEffect(() => {
    const relationshipSUbLos = myStanceData.map((res: any) => {
      return res?.relationships?.subLOs?.data;
    });
    const arr: any = [];
    relationshipSUbLos.flat(1).forEach((item1: any) => {
      sectionData?.included.forEach((item2: any) => {
        if (item1?.id === item2?.id) {
          arr.push(item2);
        }
      });
    });
    const documents = arr.filter((res: any) => {
      return (
        res?.attributes?.tags?.includes(constants.P_DOCUMENTS) &&
        sectionData.included.filter((item: any) => {
          return item?.id === res?.relationships?.enrollment?.data?.id;
        })[0]?.attributes.state === "COMPLETED"
      );
    });
    const exercise = arr.filter((res: any) => {
      return (
        res?.attributes?.tags?.includes(constants.P_EXERCISE) &&
        sectionData.included.filter((item: any) => {
          return item?.id === res?.relationships?.enrollment?.data?.id;
        })[0]?.attributes.state === "COMPLETED"
      );
    });
    const videos = arr.filter((res: any) => {
      return (
        res?.attributes?.tags?.includes(constants.P_VIDEOS) &&
        sectionData.included.filter((item: any) => {
          return item?.id === res?.relationships?.enrollment?.data?.id;
        })[0]?.attributes.state === "COMPLETED"
      );
    });
    setProgressBarData({
      documents: documents.length,
      videos: videos.length,
      exercise: exercise.length,
      liveMeetings: 153,
    });
  }, [myStanceData]);

  // const weekStartDate = moment('2024-07-30')
  const result = myStanceData?.map((res: any) => {
    return res?.relationships?.enrollment?.data?.id;
  });
  const finishedWeekData = () => {
    if (result) {
      const arr1: any = [];
      for (let i = 0; i < result?.length; i++) {
        for (let j = 0; j < sectionData?.included?.length; j++) {
          if (sectionData.included[j]?.id === result[i]) {
            arr1.push(sectionData?.included[j]);
          }
        }
      }
      return arr1;
    }
  };
   const programCardRedrection =(res:any,learningProgramData:any)=>{
    if(!isEnrollmentDateAvailable(availableQuater?.start)){
       dispatch({type:ActionType.ALERT_BOX,payload:{
                     visible:true,
                     message:t('AlertDialog.disablePCardMsg')
                   }})
        return
    }
    navigate(`/program-overview?programId=${res?.id}`,
                {
                  state: {
                    year: `${availableQuater?.quarter}-${availableQuater?.year}`,
                    programCountEachQuarter:learningProgramData?.data
                  },
                }
              )
  }
  const isEnrollmentOpen = isEnrollmentDateAvailable(availableQuater?.start);

  return (
    <>
      {/* Current Live Program */}
      {loading ? (
        <PageLoader />
      ) : (
        <>
          {!enrolledProgram?.data[0]?.length &&
          !enrolledProgram?.completed[0]?.length &&
          !enrolledProgram?.enrolledData?.length ? (
            <>
              <div className="w-[100%] mx-auto xl:px-32 lg:px-8 md:px-8 px-5 py-6 md:py-14">
                <div className="md:flex md:items-center md:justify-between">
                  <div className="min-w-0 flex-1 md:pb-6 lg:pb-12">
                    <h1 className="scroll-m-20 tracking-tight leading-7 text-2xl lg:text-3xl xl:text-4xl font-barlowLight font-light">
                      <span
                        className={`font-medium font-barlowMedium ${
                          availableQuater?.quarter === currentQuater ||
                          isEnrollmentOpen
                            ? "yellow"
                            : "text-[#767676]"
                        } `}
                      >
                        {availableQuater?.quarter}{" "}
                      </span>
                    </h1>
                    {isEnrollmentDateAvailable(availableQuater?.start) && (
                      <p
                        className="[&:not(:first-child)]:mt-6 leading-normal"
                        dangerouslySetInnerHTML={{
                          __html: `
                          <span class="text-primary">
                            ${t("Program.quarterEnrollmentOpenMsgHighLight")}
                          </span> ${t("Program.quarterEnrollmentOpenMsg")}
                          <i class="ms-4 text-2xl font-light text-primary fa fa-check-circle"></i>
                        `,
                        }}
                      />
                    )}
                  </div>
                </div>
                <div className="flex flex-col gap-6  py-12 px-6  rounded-2xl card-gray relative text-editor-dynamic-class">
                  <p
                    className="text-center text-2xl"
                    dangerouslySetInnerHTML={{
                      __html: isEnrollmentOpen? t("MyStance.enrollmentOnHeading"):t("MyStance.heading"),
                    }}
                  />

                  <span
                    className={`text-3xl font-medium font-barlowMedium ${
                      availableQuater?.quarter === currentQuater ||
                      isEnrollmentOpen
                        ? "yellow"
                        : "text-[#767676]"
                    } absolute top-12 right-6`}
                  >
                    {availableQuater?.quarter}
                  </span>
                  <p className="text-center font-Barlow-Light mb-2 text-editor-dynamic-class"
                    dangerouslySetInnerHTML={{
                      __html: isEnrollmentOpen
                        ? t("MyStance.enrollmentOnMessage")
                        : t("MyStance.enrollmentNotification"),
                    }}
                  ></p>

                  <div className="max-sm:flex-wrap max-sm:flex-col sm:flex-wrap sm:flex-col md:flex-wrap lg:flex-nowrap gap-5 items-stretch mt-10 -ml-0 sm:-ml-5 portrait:sm:-ml-0 portrait:md:-ml-5 flex lg:flex-row lg:gap-0 md:gap-0 md:gap-y-5 md:flex md:flex-row">
                    {learningProgramData?.data
                      .sort((a: any, b: any) =>
                        b?.attributes?.localizedMetadata[0]?.name.localeCompare(
                          a?.attributes?.localizedMetadata[0]?.name,
                          "es",
                          { sensitivity: "base" }
                        )
                      )
                      ?.slice(0, 2)
                      .slice(0, 2)
                      ?.map((res: any, index: number) => {
                        return (
                          <>
                            <div
                              key={`quater-list-${index}`}
                              onClick={() =>programCardRedrection(res,learningProgramData)}
                              className="landscape:2xl:basis-1/2 landscape:xl:basis-1/2 landscape:lg:basis-1/2 landscape:md:basis-1/1 portrait:md:basis-1/1 md:pl-5 w-full"
                            >
                              {index <= 2 && (
                                <DisabledCardPopOver
                                text={t('AlertDialog.disablePCardMsg')}
                                component={
                                <LearningProgramCard
                                  cardInfo={res}
                                  quater={availableQuater?.quarter}
                                  quarterStartDate={availableQuater?.start}
                                  responseData={learningProgramData}
                                  isEnrollmentOpen={isEnrollmentOpen}
                                  completed={enrolledProgram?.completed}
                                />}
                                 show={!isEnrollmentDateAvailable(availableQuater?.start)}
                                />
                              )}
                            </div>
                          </>
                        );
                      })}
                  </div>
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="w-[100%] mx-auto xl:px-32 lg:px-8 md:px-8 px-5 py-6 md:py-14">
                <div className="md:flex md:items-center md:justify-between">
                  <div className="min-w-0 flex-1 md:pb-6 lg:pb-12">
                    <h1 className="scroll-m-20 tracking-tight leading-7 text-2xl lg:text-3xl xl:text-4xl font-barlowLight font-light">
                      <span
                        className="font-medium font-barlowMedium text-primary pe-4"
                        dangerouslySetInnerHTML={{
                          __html: availableQuater?.quarter,
                        }}
                      ></span>
                      <span
                        dangerouslySetInnerHTML={{
                          __html: t("MyStance.currentProgram"),
                        }}
                      ></span>&nbsp;
                      <span
                        className="font-barlowLight font-medium"
                        dangerouslySetInnerHTML={{
                          __html: getLocalizedContent(
                            enrolledProgram?.enrolledData[0]?.attributes
                              ?.localizedMetadata
                          )?.name,
                        }}
                      ></span>
                    </h1>
                  </div>
                  <div className="mt-5 flex lg:ml-4 lg:mt-0 mb-4 md:mb-0 md:pb-6 lg:pb-12 relative z-[2]">
                    <Button
                      onClick={() => navigate("/home/quater-list")}
                      variant="secondary"
                      className="text-base font-normal px-6 py-1 h-9 dark:bg-fillMidGrayCard"
                      dangerouslySetInnerHTML={{ __html: t("Common.seeAll") }}
                    />
                  </div>
                </div>

                <div className="flex flex-col md:grid md:grid-flow-col md:grid-rows-7 lg:grid-rows-7 testt xl:grid-rows-5 gap-4 lg:gap-x-4 xl:gap-x-8 2xl:gap-x-12 relative">
                  <span
                    className="before:block before:absolute before:-inset-1 before:h-6 before:w-full relative inline-block before:left-0 before:right-0 before:top-0 mystance-bgstrip"
                    style={{
                      position: "absolute",
                      width: "100%",
                      marginTop: "-34px",
                      height: "38px",
                      zIndex: "1",
                    }}
                  ></span>
                  {myStanceData.map((res: any, index: any) => {
                    return (
                      <>
                        <div className="flex flex-col md:w-[352px] lg:w-auto my-1 p-4 dark:card-gradient-gray dark:text-white border dark:border-slate-50 rounded-2xl relative">
                          <div className="flex flex-row justify-between w-full">
                            <div className=" inline-flex flex-row">
                              <div className="flex items-center text-xs border bg-[#181818] p-1 rounded-md text-white px-1.5">
                                <p className="w-[8px] h-[8px] rounded-lg bg-red-500 me-2"></p>
                                <p
                                  className="uppercase text-red-50"
                                  dangerouslySetInnerHTML={{
                                    __html: t("Program.liveProgram"),
                                  }}
                                ></p>
                              </div>
                              <div className="mx-3 p-1  font-barlowMedium text-xs uppercase rounded dark:bg-white dark:text-black w-[90px] text-center">
                                {checkWeekStatus(
                                  myStanceData[index - 1]?.startDate
                                ) === constants.LIVE
                                  ? t(`MyStance.${constants.NEXT}`)
                                  : t(
                                      `MyStance.${checkWeekStatus(
                                        res?.startDate
                                      )}`
                                    )}
                              </div>
                            </div>
                            <div className=" inline-flex">
                              <p className=" font-barlowMedium text-base capitalize">
                                {res?.startDate.format("MMM DD")}
                              </p>
                            </div>
                          </div>
                          <div className="flex flex-row justify-between w-full mt-4">
                            <div className="block font-sans font-light pr-4">
                              {/* <span className="text-base font-opensansSemiBold pe-2">Week 1:</span> Lorem ipsum Ut enim ad minim. */}
                              <span>
                                {
                                  getLocalizedContent(
                                    res?.attributes?.localizedMetadata
                                  )?.name
                                }
                              </span>
                            </div>
                            <div className=" inline-flex">
                              <Button
                                disabled={
                                  checkWeekStatus(res?.startDate) ===
                                  constants.UPCOMING
                                }
                                variant="secondary"
                                onClick={() =>
                                  navigate(
                                    `/program/${enrolledProgram?.enrolledData[0]?.id}?activeWeek=${res?.id}`
                                  )
                                }
                                className="text-base font-normal px-3 py-1 h-9 border dark:bg-fillMidGrayCard dark:border-gray-50 w-[100%] justify-between"
                              >
                                {checkWeekStatus(res?.startDate) ===
                                constants.LIVE
                                  ? t("MyStance.continue")
                                  : checkWeekStatus(res?.startDate) ===
                                    constants.PAST
                                  ? t("MyStance.revisit")
                                  : t("MyStance.startNow")}
                                {checkWeekStatus(res?.startDate) !==
                                  constants.UPCOMING && (
                                  <img
                                    src={ArrowRight}
                                    alt="No Image"
                                    className="w-[16px] h-[16px]"
                                  />
                                )}
                              </Button>
                            </div>
                          </div>

                          <span
                            className="before:block before:absolute before:[&:nth-child(-n+2)]:none before:-inset-1  test2 before:-skew-y-3 before:h-6 before:w-[1px] before:bg-fillDarkGrayCard relative inline-block before:left-[50%] before:right-[50%] before:top-[-41px]"
                            style={{ position: "absolute", left: "50%" }}
                          ></span>
                        </div>
                      </>
                    );
                  })}
                </div>
              </div>
            </>
          )}
          {/* Fundamental Program */}
          <FundamentalProgram showSeeAll={true} />
          {/* My Progress */}
          {myStanceData.length > 0 && (
            <MyProgress
              name={
                getLocalizedContent(
                  enrolledProgram?.enrolledData[0]?.attributes?.localizedMetadata
                )?.name
              }
              progressBarData={progressBarData}
              progressBarCount={myStanceData?.length} //14 hai
              finishedWeekData={finishedWeekData}
            />
          )}

          {/* Achievements */}
          <Achievements goToBadgesRef={goToBadgesRef} />
          {/* My Classes */}
          <MyClasses />
        </>
      )}
    </>
  );
};
export default withAlmToken(MyStance);
